/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { inject, Injectable } from '@angular/core';
import { TenantId } from '@src/app/model/abstract-object';
import { MessageService } from '@src/app/shared/message.service';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private msgSvc = inject(MessageService);
  private _currentTenantId: TenantId;
  private readonly baseAjaxPath = '/api/api';
  private static _instance: TenantService;

  static get bareAjaxPath() : string {
    return TenantService._instance.baseAjaxPath + '/';
  }

  static get ajaxPath() : string {
    return TenantService._instance.ajaxPath;
  }

  constructor() {
    TenantService._instance = this;
  }

  getCurrentTenantId() : TenantId {
    return this._currentTenantId;
  }

  setCurrentTenantId(tenantId: TenantId) {
    if (tenantId === ':tenantId') {
        this.msgSvc.showErrorMessage($localize `Invalid tenant Id`);
        if (window.location.pathname !== '/') {
            window.location.href = '/';
        }
        throw new Error('Invalid tenantId');
    }

    if (this._currentTenantId !== tenantId) {
        console.log('Setting current tenant ' + tenantId);
        this._currentTenantId = tenantId;
    }
  }

  get ajaxPath() : string {
    return `${this.baseAjaxPath}/${this._currentTenantId}/`;
  }

  getPath(path) {
    return `${this.ajaxPath}${path}`;
  }

}
